import { isBoolean } from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { AppContext } from 'providers/AppProvider';
import { columns } from './Details.consts';
import { ContractSigner, ProcessesResponse } from 'types';
import { QueryString } from 'helpers';

export function useDetails() {
	const { agreementProcessId } = useParams();
	const ctx = useContext(AppContext);
	const { config, http } = ctx;
	const { API } = config;
	const url = API.getContractSigners + QueryString({ agreementProcessId });
	const { data, mutate } = useSWR<ProcessesResponse[]>(API.getProcesses);
	const process = data?.find(x => agreementProcessId === x.agreementProcessId);
	const [selectedStatus, setSelectedStatus] = useState(process ? `${process.processStatus}` : '');

	const refresh = useCallback(() => {
		mutate();
	}, [mutate]);

	const onSelect = useCallback((e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setSelectedStatus(e.target.value);
	}, []);

	const onSubmit = useCallback(
		(e: any) => {
			e.preventDefault();
			e.stopPropagation();
			if (agreementProcessId && selectedStatus) {
				const url = `${API.changeProcessStatus}/${agreementProcessId}/${selectedStatus}`;
				http.post(url, {}).then(refresh);
			}
		},
		[API, http, agreementProcessId, selectedStatus, refresh]
	);

	const onCancel = useCallback(
		(e: any) => {
			e.preventDefault();
			e.stopPropagation();
			http.delete(`${API.deleteProcess}/${agreementProcessId}`).then(refresh);
		},
		[API, http, agreementProcessId, refresh]
	);

	useEffect(() => {
		process && setSelectedStatus(`${process.processStatus}`);
	}, [process]);

	return {
		...ctx,
		...useSWR<ContractSigner[]>(url),
		agreementProcessId,
		columns,
		onCancel,
		onSelect,
		onSubmit,
		process,
		selectedStatus,
		formatValue
	};
}

function formatValue(x: string | boolean, translate: Function) {
	if (isBoolean(x)) {
		return translate(x ? 'yes' : 'no');
	}
	return x;
}
